import { LegacyDevice } from './device';
import { get_z3k_object_state, GuardZone, HeatingCircuit } from 'z3k-config';
import { SimID } from 'console/sim/types';
import { billedSimState } from 'console/sim/utils/state';
import { Capability } from 'console/device/device-capability';
export var RunMethod;
(function (RunMethod) {
    RunMethod[RunMethod["speed"] = 0] = "speed";
    RunMethod[RunMethod["coord"] = 1] = "coord";
    RunMethod[RunMethod["can"] = 2] = "can";
})(RunMethod || (RunMethod = {}));
export var InputsType;
(function (InputsType) {
    InputsType[InputsType["None"] = -1] = "None";
    InputsType[InputsType["Digital"] = 0] = "Digital";
    InputsType[InputsType["Probeg"] = 1] = "Probeg";
    InputsType[InputsType["PassengersCount"] = 2] = "PassengersCount";
    InputsType[InputsType["Flow"] = 3] = "Flow";
    InputsType[InputsType["AlarmButton"] = 4] = "AlarmButton";
    InputsType[InputsType["Ignition"] = 5] = "Ignition";
    InputsType[InputsType["AddRPM"] = 6] = "AddRPM";
    InputsType[InputsType["Belt"] = 7] = "Belt";
    InputsType[InputsType["FuelStat"] = 8] = "FuelStat";
    InputsType[InputsType["Analog_Dut_2"] = 9] = "Analog_Dut_2";
    InputsType[InputsType["Temperature"] = 10] = "Temperature";
    InputsType[InputsType["Analog"] = 11] = "Analog";
    InputsType[InputsType["Distrib"] = 12] = "Distrib";
    InputsType[InputsType["Analog_Dut_3"] = 13] = "Analog_Dut_3";
    InputsType[InputsType["Analog_Dut_4"] = 14] = "Analog_Dut_4";
    InputsType[InputsType["Analog_Dut_5"] = 15] = "Analog_Dut_5";
    InputsType[InputsType["Analog_Dut_1"] = 16] = "Analog_Dut_1";
})(InputsType || (InputsType = {}));
export var RegParamsType;
(function (RegParamsType) {
    RegParamsType[RegParamsType["default_reg_param"] = 0] = "default_reg_param";
    RegParamsType[RegParamsType["Analog_Dut_1_NormalSupplyVoltage"] = 3] = "Analog_Dut_1_NormalSupplyVoltage";
    RegParamsType[RegParamsType["Analog_Dut_2_NormalSupplyVoltage"] = 10] = "Analog_Dut_2_NormalSupplyVoltage";
    RegParamsType[RegParamsType["Digital_Dut_1"] = 30] = "Digital_Dut_1";
    RegParamsType[RegParamsType["Digital_Dut_2"] = 31] = "Digital_Dut_2";
    RegParamsType[RegParamsType["Digital_Dut_1_RS485_Address"] = 32] = "Digital_Dut_1_RS485_Address";
    RegParamsType[RegParamsType["Digital_Dut_2_RS485_Address"] = 33] = "Digital_Dut_2_RS485_Address";
    RegParamsType[RegParamsType["OBD2_Work_State"] = 34] = "OBD2_Work_State";
    RegParamsType[RegParamsType["Digital_Dut_1_KLine_Address"] = 36] = "Digital_Dut_1_KLine_Address";
    RegParamsType[RegParamsType["Digital_Dut_2_KLine_Address"] = 37] = "Digital_Dut_2_KLine_Address";
    RegParamsType[RegParamsType["Digital_Dut_3"] = 38] = "Digital_Dut_3";
    RegParamsType[RegParamsType["Digital_Dut_3_RS485_Address"] = 39] = "Digital_Dut_3_RS485_Address";
    RegParamsType[RegParamsType["Digital_Dut_3_KLine_Address"] = 40] = "Digital_Dut_3_KLine_Address";
    RegParamsType[RegParamsType["Analog_Dut_3_NormalSupplyVoltage"] = 41] = "Analog_Dut_3_NormalSupplyVoltage";
    RegParamsType[RegParamsType["Digital_Dut_4"] = 42] = "Digital_Dut_4";
    RegParamsType[RegParamsType["Digital_Dut_4_RS485_Address"] = 43] = "Digital_Dut_4_RS485_Address";
    RegParamsType[RegParamsType["Digital_Dut_4_KLine_Address"] = 44] = "Digital_Dut_4_KLine_Address";
    RegParamsType[RegParamsType["Digital_Dut_5"] = 45] = "Digital_Dut_5";
    RegParamsType[RegParamsType["Digital_Dut_5_RS485_Address"] = 46] = "Digital_Dut_5_RS485_Address";
    RegParamsType[RegParamsType["Digital_Dut_5_KLine_Address"] = 47] = "Digital_Dut_5_KLine_Address";
    RegParamsType[RegParamsType["Alarm_Button_Actual_Level"] = 53] = "Alarm_Button_Actual_Level";
    RegParamsType[RegParamsType["Alarm_Button_Tel_Number"] = 54] = "Alarm_Button_Tel_Number";
    RegParamsType[RegParamsType["AnalogDut_4_NormalSupplyVoltage"] = 56] = "AnalogDut_4_NormalSupplyVoltage";
    RegParamsType[RegParamsType["AnalogDut_5_NormalSupplyVoltage"] = 57] = "AnalogDut_5_NormalSupplyVoltage";
})(RegParamsType || (RegParamsType = {}));
export var TemperatureConf;
(function (TemperatureConf) {
    TemperatureConf["engine"] = "engine";
    TemperatureConf["cabin"] = "cabin";
    TemperatureConf["outside"] = "outside";
    TemperatureConf["none"] = "none";
})(TemperatureConf || (TemperatureConf = {}));
export var GSMNetworkState;
(function (GSMNetworkState) {
    GSMNetworkState["not_registered"] = "not-registered";
    GSMNetworkState["home_network"] = "home-network";
    GSMNetworkState["searching"] = "searching";
    GSMNetworkState["rejected"] = "rejected";
    GSMNetworkState["unknown"] = "unknown";
    GSMNetworkState["roaming"] = "roaming";
})(GSMNetworkState || (GSMNetworkState = {}));
export var GuardState;
(function (GuardState) {
    GuardState["enabling"] = "enabling";
    GuardState["enabled"] = "enabled";
    GuardState["disabled"] = "disabled";
})(GuardState || (GuardState = {}));
export var PowerSource;
(function (PowerSource) {
    PowerSource["main"] = "main";
    PowerSource["usb"] = "usb";
    PowerSource["battery"] = "battery";
})(PowerSource || (PowerSource = {}));
/**
 * Набираю ошибки устройства
 * 1. По симкам
 * 2. По контурам
 * 3. По охранным зонам
 */
export function getDeviceError(dev, billed_sims, autopayment_enabled, account_balance_x100) {
    const errors = [];
    if (dev.sim_in_device?.sim_type === 'billed') {
        const sim_id = dev.sim_in_device.sim_id;
        const sim = billed_sims.find((sim) => SimID.equals(sim.sim_card.id, sim_id));
        if (sim != null) {
            const sim_state = billedSimState(sim, autopayment_enabled, account_balance_x100, 
            // FIXME:
            90);
            if (sim_state.status != 'ok') {
                errors.push(sim_state.text);
            }
        }
    }
    if (LegacyDevice.has_capability(dev?.capabilities, Capability.has_thermostat) ||
        LegacyDevice.has_capability(dev?.capabilities, Capability.has_optional_thermostat)) {
        if (dev.last_boiler_state?.fail) {
            errors.push('Ошибка котла');
        }
    }
    if (LegacyDevice.has_capability(dev?.capabilities, Capability.has_z3k_settings)) {
        if (dev.z3k_config != null && dev.z3k_state != null) {
            //Проходим по контурам
            const heating_circuits_with_errors = HeatingCircuit.get.where(dev.z3k_config, (circuit) => {
                const circuit_state = get_z3k_object_state(dev.z3k_state, circuit.id);
                if (circuit_state) {
                    return HeatingCircuit.isFail(circuit_state);
                }
                return false;
            });
            heating_circuits_with_errors.forEach((circuit) => {
                errors.push(`Ошибка в контуре ${circuit.name}`);
            });
            //Проходим по охранным зонам
            const guard_zones_with_errors = GuardZone.get.where(dev.z3k_config, (zone) => {
                const zone_state = get_z3k_object_state(dev.z3k_state, zone.id);
                if (zone_state) {
                    return GuardZone.isAlarm(zone_state);
                }
                return false;
            });
            guard_zones_with_errors.forEach((zone) => {
                errors.push(`Сработала охранная зона ${zone.name}`);
            });
        }
    }
    return errors.length === 0 ? null : errors;
}
export function getDeviceFirmwareHumanVersion(dev) {
    return dev.firmware_version != null ? dev.firmware_version.join(':') : '';
}
export function getDeviceInfo(dev) {
    return {
        name: LegacyDevice.display_name(dev),
        dev_type: dev.device_type?.code ?? 'DUMMY',
        serial: dev.serial,
        firmware_version: getDeviceFirmwareHumanVersion(dev),
        online: dev.online ?? false,
    };
}
export function hasGuard(dev) {
    return (LegacyDevice.has_capability(dev?.capabilities, Capability.has_guard_state) ||
        !!dev.thermostat_enable_guard);
}
export var DevicePermission;
(function (DevicePermission) {
    DevicePermission["view_state"] = "view_state";
    DevicePermission["view_gps"] = "view_gps";
    DevicePermission["view_history"] = "view_history";
    DevicePermission["control"] = "control";
    DevicePermission["configure"] = "configure";
    DevicePermission["update_firmware"] = "update_firmware";
    DevicePermission["ext_configure"] = "ext_configure";
    DevicePermission["show_configure"] = "show_configure";
})(DevicePermission || (DevicePermission = {}));
export var DeviceTypeAppliance;
(function (DeviceTypeAppliance) {
    DeviceTypeAppliance["autoscan"] = "autoscan";
    DeviceTypeAppliance["car"] = "car";
    DeviceTypeAppliance["controller"] = "controller";
    DeviceTypeAppliance["other"] = "other";
    DeviceTypeAppliance["regulator"] = "regulator";
    DeviceTypeAppliance["security"] = "security";
    DeviceTypeAppliance["thermostat"] = "thermostat";
})(DeviceTypeAppliance || (DeviceTypeAppliance = {}));
